import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Loader2, Sparkles, Mic } from 'lucide-react';

interface TranscriptionLoadingModalProps {
  isOpen: boolean;
}

const TranscriptionLoadingModal: React.FC<TranscriptionLoadingModalProps> = ({ isOpen }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-background/80 backdrop-blur-sm"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: 'spring', damping: 20, stiffness: 300 }}
            className="bg-card/90 backdrop-blur-md border border-primary/20 rounded-2xl p-8 shadow-2xl shadow-primary/20 max-w-md w-full mx-4"
          >
            <div className="flex flex-col items-center text-center">
              <div className="relative mb-6">
                <motion.div
                  animate={{ 
                    scale: [1, 1.1, 1],
                    rotate: [0, 5, -5, 0]
                  }}
                  transition={{ 
                    duration: 3, 
                    repeat: Infinity,
                    repeatType: 'reverse'
                  }}
                  className="relative z-10"
                >
                  <div className="bg-primary/20 p-4 rounded-full">
                    <Mic className="w-12 h-12 text-primary" />
                  </div>
                </motion.div>
                <motion.div
                  animate={{ 
                    scale: [1, 1.2, 1],
                    opacity: [0.3, 0.6, 0.3]
                  }}
                  transition={{ 
                    duration: 2, 
                    repeat: Infinity,
                    repeatType: 'reverse'
                  }}
                  className="absolute inset-0 bg-primary/20 rounded-full blur-xl z-0"
                />
              </div>
              
              <h3 className="text-xl font-bold mb-2 text-primary">SinopseIA</h3>
              
              <p className="text-lg font-medium mb-6">
                Transcrição a ser gerada pela SinopseIA - Inteligência Artificial
              </p>
              
              <div className="flex items-center gap-3 mb-4">
                <motion.div
                  animate={{ rotate: 360 }}
                  transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
                >
                  <Loader2 className="w-6 h-6 text-primary" />
                </motion.div>
                <span className="text-sm text-gray-400">Processando o áudio...</span>
              </div>
              
              <div className="flex items-center justify-center gap-2 text-xs text-gray-400">
                <Sparkles className="w-4 h-4 text-primary/70" />
                <span>Utilizando tecnologia avançada de reconhecimento de voz</span>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TranscriptionLoadingModal;